export const regionConfigs = {
    nz: {
        name: 'New Zealand',
        geology: 'New Zealand',
        applicationId: 'A357389C-98BB-47E0-BF07-6D7CDF616419',
        stsScope: 'viz-crm-web-api-resource',
        stsClientSecret: process.env.REACT_APP_STS_CLIENT_SECRET || 'mmAm#GKxXeyz7rtP8htzU8r5y8kdg0YloqlSfH9#Vo9uSbq7zFZaIvvP4EE@Dh',
        stsClientId: 'viz-auth-serv-client',
        apiUrl: 'https://api.vizybility.net/',
        webUrl: 'https://dealerwebservice-api.azurewebsites.net/',
        msal: {
            clientId: 'c7a87087-fc1d-44d5-9054-4a11aaf59320',
            authority: 'https://tuataranz.b2clogin.com/tuataranz.onmicrosoft.com/B2C_1_SIGNINSIGNUP',
            knownAuthorities: ['tuataranz.b2clogin.com'],
        },
    },
    us: {
        name: 'USA',
        geology: 'USA',
        applicationId: '30203E77-726D-4788-9788-B52F6CEEA99A',
        stsScope: 'viz-crm-web-api-resource',
        stsClientSecret: process.env.REACT_APP_STS_CLIENT_SECRET || 'mmAm#GKxXeyz7rtP8htzU8r5y8kdg0YloqlSfH9#Vo9uSbq7zFZaIvvP4EE@Dh',
        stsClientId: 'viz-auth-serv-client',
        apiUrl: 'https://api.vizybility.net/',
        webUrl: 'https://dealerwebservice-api.azurewebsites.net/',
        msal: {
            clientId: '8aab1003-3c1b-4cfc-ae68-879d59e3b052',
            authority: 'https://tutaraalphaomega.b2clogin.com/tutaraalphaomega.onmicrosoft.com/B2C_1_SIGNINSIGNUP',
            knownAuthorities: ['tutaraalphaomega.b2clogin.com'],
        },
    },
};

// Region used when no client-side signal matches.
export const DEFAULT_REGION = 'nz';

// Interim client-side geo-detection (until server-side / CDN routing exists).
// Picks the best region for a first-time visitor from timezone + browser locale.
// Returns one of the keys in `regionConfigs`.
export const detectRegion = () => {
    
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';

        if (timeZone === 'Pacific/Auckland' || timeZone === 'Pacific/Chatham') {
            return 'nz';
        }

        if (timeZone.startsWith('America/')) {
            return 'us';
        }

        const languages = navigator.languages?.length
            ? navigator.languages
            : [navigator.language || ''];

        for (const lang of languages) {
            const country = lang.split('-')[1]?.toUpperCase();

            if (country === 'NZ') {
                return 'nz';
            }

            if (country === 'US') {
                return 'us';
            }
        }
    } catch (e) {
        // Intl / navigator unavailable (very old browser or non-browser env):
        // fall through to DEFAULT_REGION.
    }

    return DEFAULT_REGION;
};

// Helper function to get API configuration for a specific region
export const getApiConfig = (region) => {
    const config = regionConfigs[region];
    if (!config) {
        throw new Error(`Invalid region: ${region}`);
    }

    return {
        ApplicationId: config.applicationId,
        ContactApplicationId: config.contactApplicationId,
        URL: config.apiUrl,
        WEBURL: config.webUrl,
        POST_CONTACT_US: `${config.webUrl}DealerWebApp/SendContactEmail`,
        vizybilityConfig: {
            STS_SIGNIN_URL: "https://sts.vizybility.net/connect/token",
            STS_CLIENT_ID: config.stsClientId,
            STS_CLIENT_SECRET: config.stsClientSecret,
            STS_SCOPE: config.stsScope,
            grant_type: "password",
        },
    };
};
